module.exports = __webpack_public_path__ + "assets/images/project/changi-village/01_bak.jpg?v=35a26b4d";